export const SHOP_API_REQUEST="SHOP/API_REQUEST";
export const SHOP_API_SUCCESS="SHOP/API_SUCCESS";
export const SHOP_API_FAILED="SHOP/API_FAILED";
